const LINK_PREFIXES = ["https://www.", "http://www.", "https://", "http://"];

export function getLinkForView(link: string) {
    for (const prefix of LINK_PREFIXES) {
        if (link.startsWith(prefix)) {
            link = link.slice(prefix.length);
            break;
        }
    }

    return link;
}
